// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SalesforceHouseholdDataQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type SalesforceHouseholdDataQuery = { __typename?: 'Query', salesforceHouseholdConnection: { __typename?: 'SalesforceConnectionStatus', connected: boolean, object?: string | null }, households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, integrationClients?: Array<{ __typename?: 'IntegrationClient', id: string, name: string, kind: Types.IntegrationClientKind }> | null } | null } | null> | null } };

export type SalesforceHouseholdSuggestionsQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  prefix: Types.Scalars['String']['input'];
}>;


export type SalesforceHouseholdSuggestionsQuery = { __typename?: 'Query', salesforceHouseholdSuggestions: Array<{ __typename?: 'SalesforceHouseholdSuggestion', recordID: string, name: string, recordTypeName?: string | null }> };

export type ResolveSalesforceHouseholdRecordMutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  recordId: Types.Scalars['String']['input'];
}>;


export type ResolveSalesforceHouseholdRecordMutation = { __typename?: 'Mutation', resolveSalesforceHouseholdRecord: { __typename?: 'IntegrationClient', id: string } };

export const Operations = {
  Query: {
    SalesforceHouseholdData: 'SalesforceHouseholdData' as const,
    SalesforceHouseholdSuggestions: 'SalesforceHouseholdSuggestions' as const
  },
  Mutation: {
    ResolveSalesforceHouseholdRecord: 'ResolveSalesforceHouseholdRecord' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const SalesforceHouseholdDataDocument = gql`
    query SalesforceHouseholdData($householdId: ID!) {
  salesforceHouseholdConnection(householdID: $householdId) {
    connected
    object
  }
  households(where: {id: $householdId}) {
    edges {
      node {
        id
        integrationClients {
          id
          name
          kind
        }
      }
    }
  }
}
    `;

/**
 * __useSalesforceHouseholdDataQuery__
 *
 * To run a query within a React component, call `useSalesforceHouseholdDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceHouseholdDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceHouseholdDataQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useSalesforceHouseholdDataQuery(baseOptions: Apollo.QueryHookOptions<SalesforceHouseholdDataQuery, SalesforceHouseholdDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesforceHouseholdDataQuery, SalesforceHouseholdDataQueryVariables>(SalesforceHouseholdDataDocument, withFetchPolicyContext(options));
      }
export function useSalesforceHouseholdDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesforceHouseholdDataQuery, SalesforceHouseholdDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesforceHouseholdDataQuery, SalesforceHouseholdDataQueryVariables>(SalesforceHouseholdDataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useSalesforceHouseholdDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SalesforceHouseholdDataQuery, SalesforceHouseholdDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SalesforceHouseholdDataQuery, SalesforceHouseholdDataQueryVariables>(SalesforceHouseholdDataDocument, withFetchPolicyContext(options));
        }
export type SalesforceHouseholdDataQueryHookResult = ReturnType<typeof useSalesforceHouseholdDataQuery>;
export type SalesforceHouseholdDataLazyQueryHookResult = ReturnType<typeof useSalesforceHouseholdDataLazyQuery>;
export type SalesforceHouseholdDataSuspenseQueryHookResult = ReturnType<typeof useSalesforceHouseholdDataSuspenseQuery>;
export type SalesforceHouseholdDataQueryResult = Apollo.QueryResult<SalesforceHouseholdDataQuery, SalesforceHouseholdDataQueryVariables>;
export const SalesforceHouseholdSuggestionsDocument = gql`
    query SalesforceHouseholdSuggestions($householdId: ID!, $prefix: String!) {
  salesforceHouseholdSuggestions(householdID: $householdId, prefix: $prefix) {
    recordID
    name
    recordTypeName
  }
}
    `;

/**
 * __useSalesforceHouseholdSuggestionsQuery__
 *
 * To run a query within a React component, call `useSalesforceHouseholdSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceHouseholdSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceHouseholdSuggestionsQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      prefix: // value for 'prefix'
 *   },
 * });
 */
export function useSalesforceHouseholdSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<SalesforceHouseholdSuggestionsQuery, SalesforceHouseholdSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesforceHouseholdSuggestionsQuery, SalesforceHouseholdSuggestionsQueryVariables>(SalesforceHouseholdSuggestionsDocument, withFetchPolicyContext(options));
      }
export function useSalesforceHouseholdSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesforceHouseholdSuggestionsQuery, SalesforceHouseholdSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesforceHouseholdSuggestionsQuery, SalesforceHouseholdSuggestionsQueryVariables>(SalesforceHouseholdSuggestionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useSalesforceHouseholdSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SalesforceHouseholdSuggestionsQuery, SalesforceHouseholdSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SalesforceHouseholdSuggestionsQuery, SalesforceHouseholdSuggestionsQueryVariables>(SalesforceHouseholdSuggestionsDocument, withFetchPolicyContext(options));
        }
export type SalesforceHouseholdSuggestionsQueryHookResult = ReturnType<typeof useSalesforceHouseholdSuggestionsQuery>;
export type SalesforceHouseholdSuggestionsLazyQueryHookResult = ReturnType<typeof useSalesforceHouseholdSuggestionsLazyQuery>;
export type SalesforceHouseholdSuggestionsSuspenseQueryHookResult = ReturnType<typeof useSalesforceHouseholdSuggestionsSuspenseQuery>;
export type SalesforceHouseholdSuggestionsQueryResult = Apollo.QueryResult<SalesforceHouseholdSuggestionsQuery, SalesforceHouseholdSuggestionsQueryVariables>;
export const ResolveSalesforceHouseholdRecordDocument = gql`
    mutation ResolveSalesforceHouseholdRecord($householdId: ID!, $recordId: String!) {
  resolveSalesforceHouseholdRecord(householdID: $householdId, recordID: $recordId) {
    id
  }
}
    `;
export type ResolveSalesforceHouseholdRecordMutationFn = Apollo.MutationFunction<ResolveSalesforceHouseholdRecordMutation, ResolveSalesforceHouseholdRecordMutationVariables>;

/**
 * __useResolveSalesforceHouseholdRecordMutation__
 *
 * To run a mutation, you first call `useResolveSalesforceHouseholdRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveSalesforceHouseholdRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveSalesforceHouseholdRecordMutation, { data, loading, error }] = useResolveSalesforceHouseholdRecordMutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useResolveSalesforceHouseholdRecordMutation(baseOptions?: Apollo.MutationHookOptions<ResolveSalesforceHouseholdRecordMutation, ResolveSalesforceHouseholdRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveSalesforceHouseholdRecordMutation, ResolveSalesforceHouseholdRecordMutationVariables>(ResolveSalesforceHouseholdRecordDocument, options);
      }
export type ResolveSalesforceHouseholdRecordMutationHookResult = ReturnType<typeof useResolveSalesforceHouseholdRecordMutation>;
export type ResolveSalesforceHouseholdRecordMutationResult = Apollo.MutationResult<ResolveSalesforceHouseholdRecordMutation>;
export type ResolveSalesforceHouseholdRecordMutationOptions = Apollo.BaseMutationOptions<ResolveSalesforceHouseholdRecordMutation, ResolveSalesforceHouseholdRecordMutationVariables>;